import LStorage from './special/implession/storage/local.es6';
import HashCount from './special/implession/hashcount/main.es6';
import FirstView from "./special/implession/fv/main.es6";
import Vote from "./special/implession/vote/main.es6";
import WideArea from "./special/implession/widearea/main.es6";


window.BOCCHI = {};

// ストレージ
window.BOCCHI.LDATA = new LStorage();

// ハッシュカウントの取得と初期化
const hashCount = new HashCount();
window.BOCCHI.hashCount = hashCount;
hashCount.getAPI(()=>{
    const fv = new FirstView();
    const vote = new Vote();
    const widearea = new WideArea();
});

// ページ表示の際には一番上までスクロール
setTimeout(()=>{
    window.scroll({top: 0, behavior:'instant'});
}, 1000);

document.querySelector('.js-impression_top').addEventListener('click', ()=>{
    window.scroll({top: 0, behavior:'smooth'});
});